// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>
  <div class="location-container" @click.stop="() => $store.commit('setShowLocationDialog', false)" :style="`z-index: ${showLocationDialog ? 3 : -1}`">
    <div class="location-body" @click.stop="()=>{}">
      <div id="map"></div>
      <div class="box" ref="box">
        <div class="detail" style="margin-left: 10px;">
          <div class="detail-item-pos">{{$t('Locate')}}：{{location && location.address || $t('Unknown')}}
          </div>
        </div>
        <div class="detail">
          <div class="detail-item-pos">{{showCenter ?
            `${$t('Longitude')}：${Number(showCenter[0]).toFixed(2)}，${$t('Latitude')}：${Number(showCenter[1]).toFixed(2)}` : ''}}
          </div>
        </div>
        <div class="operate">
          <button class="locate">
            <div class="locate-item" @click="() => skipLocation()">{{$t('Use this location')}}</div>
          </button>
          <button class="locate">
            <div class="locate-item" @click="() => $store.commit('setShowLocationDialog', false)">{{$t('Close')}}</div>
          </button>
          <button class="locate">
            <div class="locate-item" @click="onReturnOrigin"><img src="../assets/position.png"/></div>
          </button>
        </div>
      </div>
      <div class="search-box" ref="search-box">
        <div class="search-input">
          <input ref="input" :placeholder="$t('Search Place')" v-model="searchInput"/>
        </div>
        <div v-if="searchInput" class="search-clean" @click="onCleanInput">
          <img src="../assets/clean.png"/>
        </div>
        <div class="search-icon">
          <img src="../assets/search.png"/>
        </div>
      </div>
      <div class="search-content" ref="search-content">
        <div class="search-content-item" v-for="(item, index) in searchContentList" :key="index"
             @click="onPlace(item)">
          <div class="search-content-item-title">{{item.place}}</div>
          <div class="search-content-item-subtitle">{{item.address}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from 'lodash.debounce'
  import PositionUtils from '../../common/utils/position_utils'
  import utils from '../../common/utils/utils'

  let originCenter = null;
  let zoom = 10;
  let map = null;
  let allowSearch = true;
  let marker = null;
  let markerIcon = null;
  let app = false;
  let scale = false;

  export default {
    data: function () {
      return {
        showCenter: null,
        searchInput: '',
        searchContentList: [],
        searchBox: false,
        location: {}
      }
    },
    watch: {
      searchInput(val) {
        if (val && val.length > 1 && allowSearch) {
          this.handleSearchPlaceList(val)
        } else {
          this.searchContentList = []
        }
      },
      showLocationDialog() {
        // if(app!=true)
        this.showSearchBox();
      }
    },
    computed: {
      showLocationDialog() {
        return this.$store.state.showLocationDialog;
      }
    },
    mounted: function () {
      app = utils.getUrlParams('app');
      scale = utils.getUrlParams('scale');
      if (scale) {
        this.$refs['box'].style.display = 'none';
        this.$refs['copyright'].style.display = 'none';
      }
      if (app) {
        this.$refs['copyright'].style.display = 'none';
      }
      const longitude = utils.getUrlParams('longitude') || utils.getUrlParams('lng');
      const latitude = utils.getUrlParams('latitude') || utils.getUrlParams('lat');
      if (longitude && latitude) {
        this.createMap(longitude, latitude);
      } else {
        this.createMap();
      }
      this.hiddenCopyright();
    },
    methods: {
      setLocation: function (loc) {
        this.$store.commit('setCurrentLocation', loc)
        this.$store.commit('setShowLocationDialog', false)
      },
      skipLocation() {
        let loc = {
          accuracy: 5000,
          alt: 0,
          country: this.location.city || this.location.province || this.$t('Unknown'),
          lat: this.location.latitude || 0,
          lng: this.location.longitude || 0,
          short_name: this.location.city || this.location.province || this.$t('Unknown'),
          street_address: this.location.address
        };
        this.setLocation(loc);
      },
      onReturnOrigin() {
        if (app) {
          WebView.sendMessage({method: 'locate'});
        } else {
          map.setCenter([originCenter[0], originCenter[1]]);
          this.showCenter = [originCenter[0], originCenter[1]];
          this.loadData(originCenter[0], originCenter[1]);
          this.markerMap(originCenter[0], originCenter[1]);
        }
      },
      onCleanInput() {
        this.searchInput = '';
        this.searchContentList = []
      },
      onPlace(item) {
        allowSearch = false;
        this.searchInput = item.city;
        this.showCenter = [item.longitude, item.latitude];
        this.searchContentList = [];
        map.setCenter([item.longitude, item.latitude]);
        this.loadData(item.longitude, item.latitude);
        this.markerMap(item.longitude, item.latitude);
        setTimeout(() => {
          allowSearch = true;
        }, 1000);
      },
      handleSearchPlaceList: debounce(function (val) {
        const that = this;
        PositionUtils.getPlaceList(val).then(res => {
          if (res.length > 10) {
            res.length = 10;
          }
          that.searchContentList = res;
        });
      }, 1000),
      showSearchBox() {
        if (app) {
          WebView.sendMessage({method: 'search'});
        } else {
          this.searchBox = !this.searchBox;
          if (this.searchBox) {
            this.$refs['input'].focus();
          } else {
            this.searchInput = '';
          }
        }
      },
      hiddenCopyright() {
        this.$nextTick(() => {
          const amapCopyright = document.getElementsByClassName('amap-copyright');
          if (amapCopyright && amapCopyright.length) {
            amapCopyright[0].style.display = "none";
            amapCopyright[0].style.visibility = "hidden";
          }
          const amapLogo = document.getElementsByClassName('amap-logo');
          if (amapLogo && amapLogo.length) {
            amapLogo[0].style.display = "none";
            amapLogo[0].style.visibility = "hidden";
          }
        })
      },
      createMap(longitude, latitude) {
        const that = this;
        map = new AMap.Map('map', {
          resizeEnable: true,
          zoom: zoom,
          center: longitude && latitude ? [longitude, latitude] : null
        });
        map.on("complete", function () {
          that.hiddenCopyright();
          const center = [map.getCenter().lng, map.getCenter().lat];
          if (!originCenter) {
            originCenter = center;
          }
          that.showCenter = center;
          that.loadData(center[0], center[1]);
          that.markerMap(center[0], center[1]);
        });
        if (!scale) {
          map.on('click', this.clickMap);
          map.on('moveend', this.listenerMap);
          map.on('zoomend', this.listenerMap);
        }
      },
      clickMap(e) {
        if (e && e.lnglat) {
          map.setCenter([e.lnglat.lng, e.lnglat.lat]);
          this.showCenter = [e.lnglat.lng, e.lnglat.lat];
          this.loadData(e.lnglat.lng, e.lnglat.lat);
          this.markerMap(e.lnglat.lng, e.lnglat.lat);
        }
      },
      listenerMap() {
        if (!map) return;
        zoom = map.getZoom();
      },
      markerMap(longitude, latitude) {
        if (isMobile) {
          markerIcon = new AMap.Icon({
            size: new AMap.Size(20, 25),
            image: `/marker.png`,
            imageSize: new AMap.Size(20, 25)
          });
        } else {
          markerIcon = new AMap.Icon({
            size: new AMap.Size(24, 30),
            image: `/marker.png`,
            imageSize: new AMap.Size(24, 30)
          });
        }
        if (marker) {
          marker.setMap(null);
        }
        marker = new AMap.Marker({
          icon: markerIcon,
          position: [longitude, latitude],
          zoom: zoom
        });
        marker.setMap(map);
      },
      loadData: debounce(function (longitude, latitude) {
        const that = this;
        PositionUtils.getPlace(longitude, latitude).then(res => {
          that.location = {
            ...res,
            longitude: longitude,
            latitude: latitude
          };
        });
      }, 500),
    }
  }
</script>

<style scoped>
  .location-container {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    pointer-events: auto;
    z-index: -1;
    -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  }

  #map {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%
  }

  .box {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    bottom: 50px;
    right: 30px;
  }

  .operate {
    display: flex;
    flex-direction: row;
    height: 30px;
    margin-bottom: 15px;
  }

  button {
    border: none;
    outline: none;
    color: rgba(255, 255, 255, 0.8);
  }

  .detail {
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    margin-bottom: 15px;
    background: #1B1933;
    opacity: 0.9;
    align-items: center;
    padding: 5px 10px;
  }

  .detail-item-pos {
    font-size: 13px;
    margin-bottom: 3px;
  }

  .locate {
    display: flex;
    flex-direction: row;
    align-items: center;
    border-radius: 8px;
    margin-left: 15px;
    overflow: hidden;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.3);
    opacity: 0.9;
    background: #1B1933;
    height: 100%;
    color: rgba(255, 255, 255, 0.8);
  }

  .locate-item {
    display: flex;
    padding: 0 10px;
    justify-content: center;
    align-items: center;
    font-size: 13px;
  }

  .locate-item:active {
    opacity: 0.5;
  }

  .locate img {
    width: 16px;
    height: 16px;
  }

  @media screen and (max-width: 960px) {
    .box {
      position: absolute;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      bottom: 25px;
      right: 10px;
    }

    .operate {
      display: flex;
      flex-direction: row;
      height: 25px;
      margin-bottom: 8px;
    }

    .detail {
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      margin-bottom: 8px;
      background: #1B1933;
      opacity: 0.9;
      align-items: center;
      padding: 3px 6px;
    }

    .detail-item-pos {
      font-size: 12px;
      margin-bottom: 1px;
    }

    .locate {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 5px;
      margin-left: 8px;
      overflow: hidden;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
      opacity: 0.9;
      background: #1B1933;
      height: 100%;
    }

    .locate-item {
      display: flex;
      padding: 0 6px;
      justify-content: center;
      align-items: center;
      font-size: 12px;
    }

    .locate img {
      width: 14px;
      height: 14px;
    }
  }

  input {
    border: none;
    outline: none;
    width: 100%;
  }

  @media screen and (min-width: 600px) {
    .location-body {
      position: relative;
      width: 90%;
      max-width: 900px;
      height: 100%;
      max-height: 700px;
    }

    .search-box {
      position: absolute;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      top: 40px;
      right: 30px;
      width: 400px;
      height: 40px;
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      background: #FFFFFF;
      border-radius: 2px;
      overflow: hidden;
    }

    .search-input {
      display: flex;
      flex: 1;
      height: 100%;
      padding-left: 15px;
      width: 100%;
      z-index: 3;
    }

    .search-clean {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 40px;
    }

    .search-clean img {
      width: 18px;
      height: 18px;
    }

    .search-clean:active img {
      opacity: 0.5;
    }

    .search-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 70px;
      background: #3385ff;
    }

    .search-icon img {
      width: 20px;
      height: 20px;
    }

    .search-content {
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 80px;
      right: 100px;
      width: 330px;
      background: #FFFFFF;

      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      z-index: 3;
    }

    .search-content-item {
      display: flex;
      flex-direction: column;
      padding: 5px 15px;
      width: 100%;
      border: 1px solid #f5f5f5;
    }

    .search-content-item:hover {
      background: #f0f0f0;
    }

    .search-content-item-title {
      display: inline-block;
      font-size: 14px;
      color: #4c4c4c;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }

    .search-content-item-subtitle {
      display: inline-block;
      font-size: 13px;
      color: #bfbfbf;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }
  }

  @media screen and (max-width: 600px) {
    .location-body {
      position: relative;
      width: 100%;
      height: 100%;
    }

    .search-box {
      position: absolute;
      display: flex;
      flex-direction: row;
      align-items: center;
      top: 30px;
      left: 15px;
      right: 15px;
      height: 40px;
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      background: #FFFFFF;
      border-radius: 2px;
      overflow: hidden;
    }

    .search-input {
      display: flex;
      flex: 1;
      height: 100%;
      padding-left: 15px;
      z-index: 3;
    }

    .search-clean {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 40px;
    }

    .search-clean img {
      width: 18px;
      height: 18px;
    }

    .search-clean:active img {
      opacity: 0.5;
    }

    .search-icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 70px;
      background: #3385ff;
    }

    .search-icon img {
      width: 20px;
      height: 20px;
    }

    .search-content {
      position: absolute;
      display: flex;
      flex-direction: column;
      top: 70px;
      left: 15px;
      width: calc(100% - 100px);
      background: #FFFFFF;
      box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.15);
      z-index: 3;
    }

    .search-content-item {
      display: flex;
      flex-direction: column;
      padding: 5px 15px;
      width: 100%;
      border: 1px solid #f5f5f5;
    }

    .search-content-item:hover {
      background: #f0f0f0;
    }

    .search-content-item-title {
      display: inline-block;
      font-size: 13px;
      color: #4c4c4c;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }

    .search-content-item-subtitle {
      display: inline-block;
      font-size: 12px;
      color: #bfbfbf;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis
    }
  }
</style>


